import TransactionsHistoryPage from './TransactionsHistoryPage';

export default TransactionsHistoryPage;
